import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { API_ROUTES } from '../../util/route.constants';
import { MANUAL_REFRESH_IDENTIFIER } from '../../util/constants';
import { AdditionalData } from '../../models/manual-refresh.interface';

@Injectable({
  providedIn: 'root'
})
export class ManualRefreshService {

  constructor(private readonly  http: HttpClient) { }

  getRefreshedData<T>(id:string, identifier:MANUAL_REFRESH_IDENTIFIER,additionalData:AdditionalData={}): Observable<{ response: T }> {
    return this.http.get<{ response: T }>(
      `${environment.cva_url}${API_ROUTES.MANUAL_REFRESH}/${id}/${identifier}?additionalData=${encodeURIComponent(JSON.stringify(additionalData))}`
    );
  }
}
